import type { TranslationKey } from '@/hooks/useTranslation';
import { Config } from 'driver.js';

export interface StepsProps {
  t: (key: TranslationKey) => string;
  isMobile: boolean;
}

export const steps = ({ t, isMobile }: StepsProps): Config['steps'] => {
  return [
    {
      element: '#simple_search',
      popover: {
        side: isMobile ? 'bottom' : 'left',
        description: t('label.label.guide.step_1.text'),
      },
    },
    {
      element: '#advanced_search',
      popover: {
        side: isMobile ? 'bottom' : 'right',
        description: t('label.label.guide.step_2.text'),
      },
    },
    {
      element: '#menu_tabs',
      popover: {
        side: isMobile ? 'bottom' : 'right',
        description: t('label.label.guide.step_4.text'),
      },
    },
    {
      element: '#floating_buttons',
      popover: {
        side: 'top',
        description: t('label.label.guide.step_3.text'),
      },
    },
  ];
};
